<template>
  <div id="room">
    <!-- <h1 style="margin-top:60px;">Room <span v-on:click="backHome">{{ getRoomId }}</span></h1> -->
    <h1 style="margin-top:32px;">ルーム <span v-if="getRoomId!=0">{{ getRoomId }}</span><span v-else>情報を取得中です．</span></h1>

    <div>
      <v-row class="room-component">
        <v-col>
          <!-- <v-card
            class="mx-auto my-3"
            max-width="720"
            color="#DDDDFF"
          > -->
          <v-card
            class="mx-auto my-3"
            max-width="720"
            elevation=0
          >
            <!-- <p style="color:#FFFFFF;background-color:#5555BB"><b>ゲーム情報</b></p> -->
            <!-- <div class="member-detail" style="padding-top:4px;"> -->
            <div class="member-detail" style="">
              <memberDetail ></memberDetail>
            </div>
            <div class="user-table">
              <userTable v-on:show-modal="showModal"></userTable>
            </div>
            <div class="round-table" style="padding-bottom:4px;">
              <roundTable v-on:show-modal="showModal"></roundTable>
            </div>
          </v-card>
        </v-col>

        <v-col>
          <game v-on:show-modal="showModal" v-on:start-game="startGame"></game>
        </v-col>
      </v-row>

      <!-- コンポーネント MyModal -->
      <plotModal @close="closeModal" v-if="modal" class="plot-modal-window">
          <!-- default スロットコンテンツ -->
          <p><b>{{ modalContent.title }}</b></p><p style="white-space:pre-wrap; word-wrap:break-word; text-align: left;">{{ modalContent.text }}</p>
          <!-- /footer -->
      </plotModal>

    </div>
  </div>
</template>
<script>
import userTable from '@/components/UserTable.vue'
import roundTable from '@/components/RoundTable.vue'
import memberDetail from '@/components/MemberDetail.vue'
import game from '@/components/Game.vue'
import plotModal from '@/components/PlotModal.vue'
// import getInviteUrl from '@/components/roomComponents/GetInviteUrl.vue'

export default {
  name: 'room',
  components: {
    userTable,
    roundTable,
    memberDetail,
    game,
    plotModal,
    // getInviteUrl
  },
  data() {
    return {
      // roomId: this.$route.params.roomId,
      // userName: this.$route.params.userName,
      roomId: this.$route.query.roomid,
      userName: this.$route.query.username,
      buttonMode: this.$route.query.mode,
      modalContent: {title:'', text:''},
      modal: false,
      // type: this.$route.params.type,
      isWaiting: true,
      roomState: 0,
      isHost: this.$store.state.userInfo.isHost,

      snackTexts: [],
      isShow: false,

      stop: true
    }
  },
  methods: {
    showModal(modalContent){
      console.log("showModal")
      this.modal = true
      this.modalContent = modalContent
    },
    closeModal() {
      this.modal = false
    },
    sendRequest(json) {
      console.log("Sending Message...")
      console.log(json)
      this.socket.send(JSON.stringify(json))
    },
    openSnackbar(text) {
      this.isShow = true
      this.snackTexts.unshift(text)
    },
    startGame() {
      this.isWaiting = false
    },
    backHome() {
      if (this.socket){this.socket.close()}
      this.$store.commit('clearUserInfo')
      this.$store.commit('clearGameInfo')
      this.$store.commit('clearMissionInfo')
      this.$store.commit('clearUserList')
      this.$router.push({ name: 'Home', params: {}})
    },
    // handler (event) {
    //   if (this.stop) {
    //     event.returnValue = 'ページを離れるとゲームに復帰できません．'
    //   }
    // }
  },
  computed: {
    getRoomId() {
      console.log("[Room] roomId: " + this.$store.state.gameInfo.roomId)
      return this.$store.state.gameInfo.roomId
    },
    socket() {
      return this.$store.state.webSocket.socket
    }
  },
  created() {
    if (this.roomId) {
      this.$store.commit('setRoomId', {'roomId': String(this.roomId)})
    }
    // ページ生成時の処理
    // const roomId = String(this.roomId)
    //
    // const loadedGame = {
    //     roomId: roomId,
    //     masterId: 1111,
    //     masterName: "user1",
    //     leader: 1111,
    //     state: "ready",
    //     result: ["-","-","-","-","-"]
    // };
    //
    // this.$store.commit('setGameInfo', loadedGame)

    // window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    // window.removeEventListener("beforeunload", this.handler)
  }
}

</script>
<style>
#room .room-component {
  padding-left: 12px;
  padding-right: 12px;
}
#room .member-detail {
  padding-right:8px;
  padding-left:8px;
}
#room .user-table {
  display:block;
  /* margin: 16px 32px; */
  width: auto;
  padding-right:8px;
  padding-left:8px;
  /* min-width: 460px */
}
#room .round-table {
  display:block;
  padding-right:8px;
  padding-left:8px;
  width: auto;
}
#room .plot-modal-window {
  padding: 0 48px;
}
/* .mx-auto {
  margin-top: 12px;
  margin-bottom: 12px;
} */
</style>
